<template>
  <div class="customize_container">
    <div class="customize_title">
      <div class="step_title">選擇種類</div>
    </div>
    <div class="center">
      <div class="pic_pc" v-if="deviceWidth >= 768">
        <img v-for="(item, index) in goldWebImg"
          :key="index"
          :src="item.currentImage"
          @click="changeCustom(item.name, index)"
          @mouseover="item.currentImage = item.hoverImage"
          @mouseout="onMouseout(item.name, index)"/>
      </div>
      <div class="pic_mobile" v-else>
        <img v-for="(item, index) in goldMobileImg"
          :key="index"
          :src="item.currentImage"
          @click="changeCustom(item.name, index)"
          @mouseover="item.currentImage = item.hoverImage"
          @mouseout="onMouseout(item.name, index)"/>
      </div>
    </div>
    <StepPreNext
     :hidePreButton="true"
     @nextClick="nextStep"
    ></StepPreNext>
  </div>
</template>
<script>
import matalAF from "@/images/metal_af@2x.png";
import matalAG from "@/images/metal_ag@2x.png";
import StepPreNext from "@/components/StepPreNext.vue";
import path1 from "@/images/shape-metal_af-gold@2x.png";
import path2 from "@/images/shape-metal_ag-gold@2x.png";
import path3 from "@/images/shape-metal_af-mobile-gold@2x.png";
import path4 from "@/images/shape-metal_ag-mobile-gold@2x.png";

export default {
  name: "customizeFan",
  components: {
    StepPreNext
  },
  created() {
    this.deviceWidth = window.innerWidth;
  },
  data() {
    return {
      deviceWidth: null,
      currentShape: null,
      goldWebImg: [
        {
          name: "濟公扇",
          currentImage: require("@/images/shape-metal_af@2x.png"),
          defaultImage: require("@/images/shape-metal_af@2x.png"),
          hoverImage: path1
        },
        {
          name: "媽祖扇",
          currentImage: require("@/images/shape-metal_ag@2x.png"),
          defaultImage: require("@/images/shape-metal_ag@2x.png"),
          hoverImage: path2
        }
      ],
      goldMobileImg: [
        {
          name: "濟公扇",
          currentImage: require("@/images/shape-metal_af-mobile@2x.png"),
          defaultImage: require("@/images/shape-metal_af-mobile@2x.png"),
          hoverImage: path3
        },
        {
          name: "媽祖扇",
          currentImage: require("@/images/shape-metal_ag-mobile@2x.png"),
          defaultImage: require("@/images/shape-metal_ag-mobile@2x.png"),
          hoverImage: path4
        }
      ]
    };
  },
  computed: {
    imgULR() {
      let matalCode = this.$store.getters.getComponentCode;
      switch (matalCode) {
        case "AF":
          return matalAF;
        case "AG":
          return matalAG;
        default:
          return null;
      }
    }
  },
  methods: {
    goToStep4(code) {
      const metal = this.$store.getters.customizeMetalByComponentCode(code);
      this.$store.dispatch("updateCostom", {
        key: "shape",
        content: metal.shape
      });
      this.$store.dispatch("updateCostom", {
        key: "style",
        content: metal.name
      });
      this.$store.dispatch("updateCostom", {
        key: "accessory",
        content: metal.accessory[0]
      });
      this.$store.dispatch("updateCostom", {
        key: "text",
        content: { templeName: "", godName: "", gift: "", respect: "" }
      });
      this.$store.dispatch("updateComponentCode", metal.code);
      this.$store.dispatch("setIsGoToStep3", true);
      this.imgSaveToDataURL();
      this.$router.push({ name: "customize_step4" });
    },
    imgSaveToDataURL() {
      let matalImage = new Image();
      matalImage.src = this.imgULR;
      matalImage.onload = function() {
        var canvas = document.createElement("canvas"),
          width = matalImage.width,
          height = matalImage.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(matalImage, 0, 0, width, height);
        let dataURL = canvas.toDataURL("image/png");
        this.$store.dispatch("updataCanvasDataUrl", dataURL);
        this.$router.push({ name: "customize_step4" });
      }.bind(this);
    },
    changeCustom(itemName, index) {
      this.currentShape = itemName;

      // reset 圖片
      this.goldWebImg.forEach(item => {
        item.currentImage = item.defaultImage;
      });
      this.goldMobileImg.forEach(item => {
        item.currentImage = item.defaultImage;
      });

      // 顯示 hover 圖片
      this.goldWebImg[index].currentImage = this.goldWebImg[index].hoverImage;
      this.goldMobileImg[index].currentImage = this.goldMobileImg[
        index
      ].hoverImage;
    },
    onMouseout(itemName, index) {
      if (itemName !== this.currentShape) {
        this.goldWebImg[index].currentImage = this.goldWebImg[
          index
        ].defaultImage;
        this.goldMobileImg[index].currentImage = this.goldMobileImg[
          index
        ].defaultImage;
      }
    },
    nextStep() {
      switch (this.currentShape) {
        case "濟公扇":
        default:
          this.goToStep4("AF");
          break;
        case "媽祖扇":
          this.goToStep4("AG");
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.customize_container {
  position: relative; // 下一步按鈕定位用
  margin-top: 30px;
  padding-bottom: 60px;

  // 不能用 ::v-deep 寫法，因為 node-sass 不支援，它不會編譯成編號
  /deep/ .step-pre-next {
    top: 20vh;
    @include table {
      display: block;
      top: -7px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  z-index: 99;
  position: relative;
  margin-left: 20%;
  margin-right: 20%;
  @media all and (min-width: 1440px) {
    width: 864px;
    margin: auto;
  }
  @include table {
    z-index: 1;
    margin-top: 150px;
  }
  @include betweenPhoneTable {
    margin-left: 10%;
    margin-right: 10%;
  }
  @include phone {
    margin-left: 2%;
    margin-right: 2%;
  }
}
.pic_pc {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  img {
    width: 200px;
    height: auto;
    padding: 10px;
  }
}
.pic_mobile {
  img {
    width: 90%;
  }
  img + img {
    margin-top: 10px;
  }
}
</style>
